import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { publish, refCount } from 'rxjs/operators';

import * as esri from 'esri-leaflet';
import { FeatureCollection } from 'geojson';
import { HttpClient } from '@angular/common/http';
import { getGisToken } from '@app/modules/gis/gis-token';

@Injectable()
export class FieldDataService {

    constructor(
        private http: HttpClient
    ) {
    }

    public queryFieldData(url: string, geometry: any, attributes: string[], returnGeometry = false): Observable<FeatureCollection> {
        return new Observable<FeatureCollection>(observer => {
            getGisToken().then(token => {
                const query = esri.query({ url, useCors: true, withCredentials: true }).token(token);
                query.intersects(geometry).returnGeometry(returnGeometry).fields(attributes)
                    .run((error, featureCollection: FeatureCollection) => {
                        if (error) {
                            observer.error(error);
                        } else {
                            observer.next(featureCollection);
                            observer.complete();
                        }
                    });
            });
        }).pipe(publish(), refCount());
    }
}
